import { IExportInvoices } from "us.collection.economy/interfaces/ClientInvoices";

export function ExportInvoices(this: any): IExportInvoices {
  return {
    exportType: this.exportType,
    invoices: this.invoices,
  };
}
